<template>
    <div class="c-error" :class="[customClass, {'is-open': isOpen}]">
        <v-toggle custom-button-class="c-error-toggle" v-model="isOpen" :arrow-icon="false" content-class="c-error__content">
            <span slot="toggle-button">
                <span aria-hidden="true">?</span>
            </span>
            <slot></slot>
        </v-toggle>
    </div>
</template>

<script>
    import VToggle from '@/components/Toggle'

    export default {
        data(){
          return {
              isOpen: false
          }
        },
        components: {
            VToggle,
        },
        props: ['custom-class']
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-error {
        color: $color-error;

        &.is-open{

        }
    }

    .c-error-toggle{
        position: absolute;
        top: 0;
        right: -28px;
        width: em(30px, 16px);
        height: em(30px, 16px);
        background-color: $color-error;
        color: white;
        font-weight: $extra-bold;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        @include rfs(13px);
    }

    .c-error__content{
        font-weight: $semi-bold;
        @include rfs($font-size-small);
        box-shadow: 0 0 0 3px $color-error;
        padding: em($global-spacing-unit-tiny);
        background-color: $color-error;
        color: white;
        position: absolute;
        z-index: 5;
        top: calc(100% + 3px);
        right: -50px;

        &:after{
            $width: 10px;
            $height: 5px;
            content:'';
            position: absolute;
            width: 0;
            height: 0;
            top: -($height + 3px);
            right: em($global-spacing-unit);
            border-left: $width solid transparent;
            border-right: $width solid transparent;
            border-bottom: $height solid $color-error;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/form/Error.vue